module.exports = __webpack_public_path__ + "img/798.957e851c.png";